import { TenantUserInvitationStatus } from '@/common/viewModels/Enums';

export class TenantUserInvitation {
    id?: string;
    status?: TenantUserInvitationStatus;
    unixTimestamp?: number;
    unixTimestampExpiringDate?: number;
    dateDescription?: string;
    expiringInDays?: number;
}
